/** Squirtle Squad — gemeinsame UI-Helfer für Tax- und Raw-Tabellen */

export const SQUIRTLE_SQUAD_CLASSES = new Set([
  "squad_game_spend",
  "squad_game_reward",
  "squad_nft_upgrade_spend",
  "squad_nft_upgrade_burn",
  "squad_nft_upgrade_mint",
  "squad_preico_payment",
  "squad_preico_forward",
  "squad_preico_claim",
]);

/** Steuerlich relevante Outflows (FIFO / Disposal) */
export const SQUIRTLE_SQUAD_DISPOSAL_CLASSES = new Set([
  "squad_game_spend",
  "squad_nft_upgrade_spend",
  "squad_preico_payment",
]);

export const SQUIRTLE_SQUAD_TYPE_FILTER_OPTIONS = [
  { value: "squad_game_spend", label: "🐢 Squirtle Squad Game Spend" },
  { value: "squad_nft_upgrade_spend", label: "🐢 Squirtle Squad NFT Upgrade Spend" },
  { value: "squad_nft_upgrade_burn", label: "🐢 Squirtle Squad NFT Upgrade Burn" },
  { value: "squad_nft_upgrade_mint", label: "🐢 Squirtle Squad NFT Upgrade Mint" },
  { value: "squad_preico_payment", label: "🐢 Squirtle Squad Pre-ICO Payment" },
  { value: "squad_preico_forward", label: "🐢 Squirtle Squad Pre-ICO Forward" },
  { value: "squad_game_reward", label: "🐢 Squirtle Squad Game Reward" },
  { value: "squad_preico_claim", label: "🐢 Squirtle Squad Pre-ICO Claim" },
];

export function isSquirtleSquadClass(cls) {
  return SQUIRTLE_SQUAD_CLASSES.has(String(cls || "").toLowerCase());
}

export function isSquirtleSquadDisposalLike(cls) {
  return SQUIRTLE_SQUAD_DISPOSAL_CLASSES.has(String(cls || "").toLowerCase());
}

export function getSquirtleSquadSubtitle(clsRaw) {
  const cls = String(clsRaw || "").trim().toLowerCase();
  switch (cls) {
    case "squad_game_spend":
      return "Game Spend";
    case "squad_game_reward":
      return "Game Reward";
    case "squad_nft_upgrade_spend":
      return "NFT Upgrade Spend";
    case "squad_nft_upgrade_burn":
      return "NFT Upgrade Burn";
    case "squad_nft_upgrade_mint":
      return "NFT Upgrade Mint";
    case "squad_preico_payment":
      return "Pre-ICO Pool";
    case "squad_preico_forward":
      return "Pre-ICO Pool Forward";
    case "squad_preico_claim":
      return "Pre-ICO Claim";
    default:
      return "";
  }
}

export function renderSquirtleSquadType(clsRaw, { imgProps } = {}) {
  const subtitle = getSquirtleSquadSubtitle(clsRaw);

  return (
    <div className="flex items-start gap-2 text-blue-600 font-semibold min-w-0">
      <img
        src="/SQUAD.png"
        alt="Squirtle Squad"
        className="h-5 w-5 object-contain flex-shrink-0 mt-0.5"
        draggable={false}
        onError={(e) => {
          e.currentTarget.style.display = "none";
        }}
        {...(imgProps || {})}
      />
      <div className="min-w-0 leading-tight">
        <div className="whitespace-normal break-words">Squirtle Squad</div>
        {subtitle ? (
          <div className="whitespace-normal break-words text-[11px] font-medium text-blue-700/90">
            {subtitle}
          </div>
        ) : null}
      </div>
    </div>
  );
}
